import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { AESService } from 'src/app/APIservices/encryption/aes.service';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	//matchingaction?:string;
}
export interface Menu1 {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
	matchingaction?: string;
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}




	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [

		{
			title: 'Product', icon: 'shopping-cart', type: 'sub', active: false, children: [
				{ path: '/ecommerce/products', title: 'Products', type: 'link' },
				{ path: '/ecommerce/addproduct', title: 'Add Product', type: 'link' },

			]
		},
		// {
		// 	title: 'Employee Portal Access', icon: 'users', type: 'sub', active: false, children: [
		// 		{ path: '/employee/list', title: 'Employee List', type: 'link' }
		// 	]
		// },
		// {
		// 	title: 'Customer Portal Access', icon: 'users', type: 'sub', active: false, children: [
		// 		{ path: '/company/list', title: 'Company List', type: 'link' }
		// 	]
		// },
		{
			title: 'CMS Users', icon: 'users', type: 'sub', active: false, children: [
				// { path: '/users/edit', title: 'Profile', type: 'link' },
				{ path: '/users/createUser', title: 'Create CMS User', type: 'link' },
				{ path: '/users/listUser', title: 'List CMS User', type: 'link' }
			]
		},
		{
			path: '/roles/addrole', title: 'Add Role', icon: 'tag', type: 'link'
		},
		{
			path: '/permissions', title: 'Permissions', icon: 'key', type: 'link'
		},
		{
			title: 'Categories', icon: 'archive', type: 'sub', active: false, children: [
				{ path: '/categories/addclass', title: 'Create Code', type: 'link' },
				{ path: '/categories/addgroup', title: 'Create Function', type: 'link' },
				{ path: '/categories/addattribute', title: 'Create Attribute', type: 'link' },
			]
		},
		// {
		// 	path: '/blog/CreateBlog', title: 'Blogs / Articles', icon: 'edit', type: 'link'
		// },

		// {
		// 	path: '/training', title: 'Training', icon: 'airplay', type: 'link'
		// },
		{
			path: '/requests', title: 'requests', icon: 'user-check', type: 'link'
		},
		{
			path: '/pages/listpages', title: 'Pages', icon: 'copy', type: 'link'
		},
		// {
		// 	path: '/news', title: 'News', icon: 'tv', type: 'link'
		// }
	]

	// Array
	MENUITEMS1: Menu1[] = [
		{
			title: 'Product', icon: 'shopping-cart', type: 'sub', matchingaction: 'productcreate', active: false, children: [
				{ path: '/ecommerce/products', title: 'Products', type: 'link' },
				{ path: '/ecommerce/addproduct', title: 'Add Product', type: 'link' },
			]
		},
		// {
		// 	title: 'Employee', icon: 'users', type: 'sub', matchingaction: 'employeecreate', active: false, children: [
		// 		{ path: '/employee/list', title: 'Employee List', type: 'link' },

		// 	]
		// },
		// {
		// 	title: 'Company', icon: 'users', type: 'sub', matchingaction: 'customercreate', active: false, children: [
		// 		{ path: '/company/list', title: 'Company List', type: 'link' },
		// 		// { path: '/customer/list', title: 'Customer List', type: 'link' }
		// 	]
		// },
		{
			title: 'Users', icon: 'users', type: 'sub', matchingaction: 'usercreate', active: false, children: [

				// { path: '/users/edit', title: 'Profile', type: 'link' },
				{ path: '/users/createUser', title: 'Create User', type: 'link' },
				{ path: '/users/listUser', title: 'List User', type: 'link' }
			]
		},

		{
			path: '/roles/addrole', title: 'Add Role', matchingaction: 'rolecreate', icon: 'tag', type: 'link'
		},


		{
			title: 'Categories', icon: 'archive', type: 'sub', matchingaction: 'categorycreate', active: false, children: [
				{ path: '/categories/addclass', title: 'Create Code', type: 'link' },
				{ path: '/categories/addgroup', title: 'Create Function', type: 'link' },
				{ path: '/categories/addattribute', title: 'Create Attribute', type: 'link' },


			]
		},

		// {
		// 	path: '/blog/CreateBlog', title: 'Blogs / Articles', matchingaction: 'blogcreate', icon: 'edit', type: 'link'
		// },

		// {
		// 	path: '/training', title: 'Training', icon: 'airplay', type: 'link'
		// },

		{
			path: '/requests', title: 'Requests', icon: 'user-check', matchingaction: 'quotecreate', type: 'link'
		},
		{
			path: '/pages/listpages', title: 'Pages', icon: 'copy', matchingaction: 'pagecreate', type: 'link'
		},
		{
			path: '/news', title: 'News', icon: 'tv', type: 'link'
		},

	]


	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
	items1 = new BehaviorSubject<Menu1[]>(this.MENUITEMS1);



}


// Add Employee path { path: '/employee/add', title: 'Add Employee', type: 'link' },

//	Add Customer { path: '/customer/add', title: 'Add Customer', type: 'link' },
